module.exports = __webpack_public_path__ + "img/sqcg.7ef09102.png";